// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Shared look of the form popups (votings): fixed header with title and close button,
 * scrolling body, fixed footer with the actions. Opened with cssClass "form-modal", so on
 * tablet/desktop the modal is a 560px card as tall as its content (body capped at 60vh).
 * Loaded with @use by each popup stylesheet. */
:host {
  justify-content: flex-start;
  font-family: var(--ion-font-family, inherit);
  background: var(--ion-background-color, #fff);
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex: 0 0 auto;
  padding: calc(16px + var(--ion-safe-area-top, 0px)) 12px 12px 20px;
  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);
}
.popup-header__text {
  min-width: 0;
}
.popup-header h2 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.35;
  overflow-wrap: anywhere;
}
.popup-header__subtitle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  margin-top: 4px;
  font-size: 13px;
  color: var(--ion-color-medium-shade);
}

.popup-close {
  display: grid;
  place-items: center;
  align-self: flex-start;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--ion-color-medium-shade);
  line-height: 0;
  cursor: pointer;
}
.popup-close ion-icon {
  display: block;
  font-size: 21px;
}
.popup-close:hover, .popup-close:focus-visible {
  outline: none;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.1);
}

.popup-body {
  flex: 1 1 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

.popup-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex: 0 0 auto;
  padding: 12px 20px calc(12px + var(--ion-safe-area-bottom, 0px));
  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);
}
.popup-footer ion-button {
  margin: 0;
  min-width: 110px;
  height: 42px;
  --border-radius: 10px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
}
@media (max-width: 575px) {
  .popup-footer ion-button {
    flex: 1;
  }
}

/* Section with a small uppercase title */
.popup-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.popup-section__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--ion-color-medium-shade);
}
.popup-section__title ion-icon {
  font-size: 16px;
  color: var(--ion-color-primary);
}

/* Field: label above a bordered input */
.popup-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.popup-field__label {
  font-size: 13px;
  font-weight: 600;
  color: var(--ion-color-step-750, #404040);
}

.popup-input,
.popup-textarea {
  width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.35);
  background: var(--ion-background-color, #fff);
  color: var(--ion-text-color, #000);
  font: inherit;
  font-size: 15px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.popup-input::placeholder,
.popup-textarea::placeholder {
  color: var(--ion-color-medium);
}
.popup-input:focus,
.popup-textarea:focus {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.18);
}

.popup-input {
  height: 48px;
  padding-top: 0;
  padding-bottom: 0;
}

.popup-textarea {
  min-height: 96px;
  line-height: 1.5;
  resize: vertical;
}

/* File row (attachments): icon, name (download), actions */
.file-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 8px 8px 8px 12px;
  border-radius: 10px;
  background: rgba(var(--ion-color-medium-rgb), 0.07);
}
.file-row > ion-icon {
  flex-shrink: 0;
  font-size: 18px;
  color: var(--ion-color-primary);
}
.file-row__name {
  flex: 1;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 14px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.file-row button.file-row__name {
  cursor: pointer;
}
.file-row button.file-row__name:hover, .file-row button.file-row__name:focus-visible {
  outline: none;
  color: var(--ion-color-primary);
  text-decoration: underline;
}

/* Small round icon button (remove, download) */
.icon-button {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--ion-color-medium);
  line-height: 0;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.icon-button ion-icon {
  font-size: 18px;
}
.icon-button:hover, .icon-button:focus-visible {
  outline: none;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.1);
}
.icon-button--danger:hover, .icon-button--danger:focus-visible {
  color: var(--ion-color-danger);
  background: rgba(var(--ion-color-danger-rgb), 0.1);
}

.required {
  color: var(--ion-color-danger);
}

/* Steps under the title: 1 bills → 2 accounting data */
.stepper {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
}
.stepper__step {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 500;
  color: var(--ion-color-medium-shade);
}
.stepper__step--active {
  font-weight: 600;
  color: var(--ion-color-primary-shade);
}
.stepper__dot {
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  color: var(--ion-color-medium-shade);
  background: rgba(var(--ion-color-medium-rgb), 0.16);
}
.stepper__dot ion-icon {
  font-size: 13px;
}
.stepper__step--active .stepper__dot, .stepper__step--done .stepper__dot {
  color: var(--ion-color-primary-contrast);
  background: var(--ion-color-primary);
}
.stepper__line {
  flex: 0 0 24px;
  height: 2px;
  border-radius: 1px;
  background: rgba(var(--ion-color-medium-rgb), 0.25);
}

.step-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
  padding: 12px 14px;
  border-radius: 12px;
  font-size: 13.5px;
  line-height: 1.5;
  color: var(--ion-color-step-800, #333);
  background: rgba(var(--ion-color-primary-rgb), 0.08);
}
.step-notice ion-icon {
  flex-shrink: 0;
  font-size: 19px;
  color: var(--ion-color-primary);
}

/* Bills to pick */
.bill-list-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  /* Fixed height: the 'N selected' pill appears on the first tick without pushing the list down */
  height: 26px;
  margin-bottom: -10px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--ion-color-medium-shade);
}

.count-pill {
  padding: 0 9px;
  line-height: 22px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
  color: var(--ion-color-primary-shade);
  background: rgba(var(--ion-color-primary-rgb), 0.12);
}

.bill-list {
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);
  border-radius: 12px;
  overflow: hidden;
}
.bill-list li + li {
  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);
}

.bill-skeleton {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 14px;
}
.bill-skeleton ion-skeleton-text {
  margin: 0;
}

.bill-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.bill-row:hover {
  background: rgba(var(--ion-color-primary-rgb), 0.04);
}
.bill-row:focus-visible {
  outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);
  outline-offset: -2px;
}
.bill-row--selected, .bill-row--selected:hover {
  background: rgba(var(--ion-color-primary-rgb), 0.07);
}
.bill-row__info {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
  min-width: 0;
}
.bill-row__title {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 8px;
  font-size: 14.5px;
  font-weight: 600;
}
.bill-row__date {
  font-size: 12.5px;
  font-weight: 500;
  color: var(--ion-color-medium-shade);
}
.bill-row__period {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12.5px;
  color: var(--ion-color-medium-shade);
}
.bill-row__period ion-icon {
  flex-shrink: 0;
  font-size: 14px;
}
.bill-row__amount {
  flex-shrink: 0;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.check-box {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 2px solid rgba(var(--ion-color-medium-rgb), 0.6);
  background: var(--ion-background-color, #fff);
  color: transparent;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.check-box ion-icon {
  font-size: 15px;
}
.check-box--on {
  border-color: var(--ion-color-primary);
  background: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
}

/* Accounting data: two columns, stacked on phones */
.field-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 14px;
}
@media (min-width: 480px) {
  .field-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.popup-field--full {
  grid-column: 1/-1;
}

/* Unit (%, €) inside the input, on the right */
.input-suffix {
  position: relative;
}
.input-suffix .popup-input {
  padding-right: 36px;
}
.input-suffix__unit {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  font-size: 14px;
  font-weight: 600;
  color: var(--ion-color-medium-shade);
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/popup/popup-expenses-note/popup-expenses-note.component.scss","webpack://./src/theme/_popup-form.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;+CAAA;AAKA;EACE,2BAAA;EACA,4CAAA;EACA,6CAAA;ADCF;;ACEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,kEAAA;EACA,gEAAA;ADCF;ACCE;EACE,YAAA;ADCJ;ACEE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ADAJ;ACGE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,oCAAA;ADDJ;;ACKA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;ADFF;ACIE;EACE,cAAA;EACA,eAAA;ADFJ;ACKE;EAEE,aAAA;EACA,+BAAA;EACA,mDAAA;ADJJ;;ACQA;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;ADLF;;ACQA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,cAAA;EACA,gEAAA;EACA,6DAAA;ADLF;ACOE;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;ADLJ;ACQE;EACE;IACE,OAAA;EDNJ;AACF;;ACUA,yCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ADPF;ACSE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oCAAA;ADPJ;ACSI;EACE,eAAA;EACA,+BAAA;ADPN;;ACYA,wCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;ADTF;ACWE;EACE,eAAA;EACA,gBAAA;EACA,yCAAA;ADTJ;;ACaA;;EAEE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yDAAA;EACA,6CAAA;EACA,kCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,0DAAA;ADVF;ACYE;;EACE,8BAAA;ADTJ;ACYE;;EACE,sCAAA;EACA,8DAAA;ADTJ;;ACaA;EACE,YAAA;EACA,cAAA;EACA,iBAAA;ADVF;;ACaA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;ADVF;;ACaA,2DAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mDAAA;ADVF;ACYE;EACE,cAAA;EACA,eAAA;EACA,+BAAA;ADVJ;ACaE;EACE,OAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ADXJ;ACcE;EACE,eAAA;ADZJ;ACcI;EAEE,aAAA;EACA,+BAAA;EACA,0BAAA;ADbN;;ACkBA,+CAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,yDAAA;ADfF;ACiBE;EACE,eAAA;ADfJ;ACkBE;EAEE,aAAA;EACA,+BAAA;EACA,mDAAA;ADjBJ;ACoBE;EAEE,8BAAA;EACA,kDAAA;ADnBJ;;AAtOA;EACE,8BAAA;AAyOF;;AAtOA,uDAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;AAyOF;AAvOE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;AAyOJ;AAvOI;EACE,gBAAA;EACA,qCAAA;AAyON;AArOE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,mDAAA;AAuOJ;AArOI;EACE,eAAA;AAuON;AAnOE;EAEE,wCAAA;EACA,oCAAA;AAoOJ;AAjOE;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,mDAAA;AAmOJ;;AA/NA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sCAAA;EACA,oDAAA;AAkOF;AAhOE;EACE,cAAA;EACA,eAAA;EACA,+BAAA;AAkOJ;;AA9NA,kBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gGAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oCAAA;AAiOF;;AA9NA;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qCAAA;EACA,oDAAA;AAiOF;;AA9NA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,yDAAA;EACA,mBAAA;EACA,gBAAA;AAiOF;AA/NE;EACE,6DAAA;AAiOJ;;AA7NA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAgOF;AA9NE;EACE,SAAA;AAgOJ;;AA5NA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AA+NF;AA7NE;EACE,oDAAA;AA+NJ;AA5NE;EACE,0DAAA;EACA,oBAAA;AA8NJ;AA3NE;EAEE,oDAAA;AA4NJ;AAzNE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;AA2NJ;AAxNE;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AA0NJ;AAvNE;EACE,iBAAA;EACA,gBAAA;EACA,oCAAA;AAyNJ;AAtNE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oCAAA;AAwNJ;AAtNI;EACE,cAAA;EACA,eAAA;AAwNN;AApNE;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;AAsNJ;;AAlNA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wDAAA;EACA,6CAAA;EACA,kBAAA;EACA,gEAAA;AAqNF;AAnNE;EACE,eAAA;AAqNJ;AAlNE;EACE,sCAAA;EACA,oCAAA;EACA,wCAAA;AAoNJ;;AAhNA,oDAAA;AACA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAmNF;AAjNE;EALF;IAMI,gDAAA;EAoNF;AACF;;AAjNA;EACE,iBAAA;AAoNF;;AAjNA,+CAAA;AACA;EACE,kBAAA;AAoNF;AAlNE;EACE,mBAAA;AAoNJ;AAjNE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,oBAAA;AAmNJ","sourcesContent":["@use \"../../../theme/popup-form\";\n\n.required {\n  color: var(--ion-color-danger);\n}\n\n/* Steps under the title: 1 bills → 2 accounting data */\n.stepper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 8px 0 0;\n  padding: 0;\n  list-style: none;\n\n  &__step {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12.5px;\n    font-weight: 500;\n    color: var(--ion-color-medium-shade);\n\n    &--active {\n      font-weight: 600;\n      color: var(--ion-color-primary-shade);\n    }\n  }\n\n  &__dot {\n    display: grid;\n    place-items: center;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--ion-color-medium-shade);\n    background: rgba(var(--ion-color-medium-rgb), 0.16);\n\n    ion-icon {\n      font-size: 13px;\n    }\n  }\n\n  &__step--active &__dot,\n  &__step--done &__dot {\n    color: var(--ion-color-primary-contrast);\n    background: var(--ion-color-primary);\n  }\n\n  &__line {\n    flex: 0 0 24px;\n    height: 2px;\n    border-radius: 1px;\n    background: rgba(var(--ion-color-medium-rgb), 0.25);\n  }\n}\n\n.step-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 0;\n  padding: 12px 14px;\n  border-radius: 12px;\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: var(--ion-color-step-800, #333);\n  background: rgba(var(--ion-color-primary-rgb), 0.08);\n\n  ion-icon {\n    flex-shrink: 0;\n    font-size: 19px;\n    color: var(--ion-color-primary);\n  }\n}\n\n/* Bills to pick */\n.bill-list-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  /* Fixed height: the 'N selected' pill appears on the first tick without pushing the list down */\n  height: 26px;\n  margin-bottom: -10px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--ion-color-medium-shade);\n}\n\n.count-pill {\n  padding: 0 9px;\n  line-height: 22px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: normal;\n  color: var(--ion-color-primary-shade);\n  background: rgba(var(--ion-color-primary-rgb), 0.12);\n}\n\n.bill-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n  border-radius: 12px;\n  overflow: hidden;\n\n  li + li {\n    border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);\n  }\n}\n\n.bill-skeleton {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 14px;\n\n  ion-skeleton-text {\n    margin: 0;\n  }\n}\n\n.bill-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 14px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background: rgba(var(--ion-color-primary-rgb), 0.04);\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);\n    outline-offset: -2px;\n  }\n\n  &--selected,\n  &--selected:hover {\n    background: rgba(var(--ion-color-primary-rgb), 0.07);\n  }\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__title {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 2px 8px;\n    font-size: 14.5px;\n    font-weight: 600;\n  }\n\n  &__date {\n    font-size: 12.5px;\n    font-weight: 500;\n    color: var(--ion-color-medium-shade);\n  }\n\n  &__period {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 12.5px;\n    color: var(--ion-color-medium-shade);\n\n    ion-icon {\n      flex-shrink: 0;\n      font-size: 14px;\n    }\n  }\n\n  &__amount {\n    flex-shrink: 0;\n    white-space: nowrap;\n    font-size: 14px;\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n  }\n}\n\n.check-box {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n  border: 2px solid rgba(var(--ion-color-medium-rgb), 0.6);\n  background: var(--ion-background-color, #fff);\n  color: transparent;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n\n  ion-icon {\n    font-size: 15px;\n  }\n\n  &--on {\n    border-color: var(--ion-color-primary);\n    background: var(--ion-color-primary);\n    color: var(--ion-color-primary-contrast);\n  }\n}\n\n/* Accounting data: two columns, stacked on phones */\n.field-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 14px;\n\n  @media (min-width: 480px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.popup-field--full {\n  grid-column: 1 / -1;\n}\n\n/* Unit (%, €) inside the input, on the right */\n.input-suffix {\n  position: relative;\n\n  .popup-input {\n    padding-right: 36px;\n  }\n\n  &__unit {\n    position: absolute;\n    top: 50%;\n    right: 14px;\n    transform: translateY(-50%);\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--ion-color-medium-shade);\n    pointer-events: none;\n  }\n}\n","/* Shared look of the form popups (votings): fixed header with title and close button,\n * scrolling body, fixed footer with the actions. Opened with cssClass \"form-modal\", so on\n * tablet/desktop the modal is a 560px card as tall as its content (body capped at 60vh).\n * Loaded with @use by each popup stylesheet. */\n\n:host {\n  justify-content: flex-start;\n  font-family: var(--ion-font-family, inherit);\n  background: var(--ion-background-color, #fff);\n}\n\n.popup-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex: 0 0 auto;\n  padding: calc(16px + var(--ion-safe-area-top, 0px)) 12px 12px 20px;\n  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n\n  &__text {\n    min-width: 0;\n  }\n\n  h2 {\n    margin: 0;\n    font-size: 17px;\n    font-weight: 600;\n    line-height: 1.35;\n    overflow-wrap: anywhere;\n  }\n\n  &__subtitle {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px 10px;\n    margin-top: 4px;\n    font-size: 13px;\n    color: var(--ion-color-medium-shade);\n  }\n}\n\n.popup-close {\n  display: grid;\n  place-items: center;\n  align-self: flex-start;\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium-shade);\n  line-height: 0;\n  cursor: pointer;\n\n  ion-icon {\n    display: block;\n    font-size: 21px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.1);\n  }\n}\n\n.popup-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n}\n\n.popup-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  flex: 0 0 auto;\n  padding: 12px 20px calc(12px + var(--ion-safe-area-bottom, 0px));\n  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n\n  ion-button {\n    margin: 0;\n    min-width: 110px;\n    height: 42px;\n    --border-radius: 10px;\n    font-weight: 600;\n    text-transform: none;\n    letter-spacing: normal;\n  }\n\n  @media (max-width: 575px) {\n    ion-button {\n      flex: 1;\n    }\n  }\n}\n\n/* Section with a small uppercase title */\n.popup-section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  &__title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    color: var(--ion-color-medium-shade);\n\n    ion-icon {\n      font-size: 16px;\n      color: var(--ion-color-primary);\n    }\n  }\n}\n\n/* Field: label above a bordered input */\n.popup-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n\n  &__label {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--ion-color-step-750, #404040);\n  }\n}\n\n.popup-input,\n.popup-textarea {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.35);\n  background: var(--ion-background-color, #fff);\n  color: var(--ion-text-color, #000);\n  font: inherit;\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &::placeholder {\n    color: var(--ion-color-medium);\n  }\n\n  &:focus {\n    border-color: var(--ion-color-primary);\n    box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.18);\n  }\n}\n\n.popup-input {\n  height: 48px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.popup-textarea {\n  min-height: 96px;\n  line-height: 1.5;\n  resize: vertical;\n}\n\n/* File row (attachments): icon, name (download), actions */\n.file-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  padding: 8px 8px 8px 12px;\n  border-radius: 10px;\n  background: rgba(var(--ion-color-medium-rgb), 0.07);\n\n  > ion-icon {\n    flex-shrink: 0;\n    font-size: 18px;\n    color: var(--ion-color-primary);\n  }\n\n  &__name {\n    flex: 1;\n    min-width: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    font-size: 14px;\n    text-align: left;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  button.file-row__name {\n    cursor: pointer;\n\n    &:hover,\n    &:focus-visible {\n      outline: none;\n      color: var(--ion-color-primary);\n      text-decoration: underline;\n    }\n  }\n}\n\n/* Small round icon button (remove, download) */\n.icon-button {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium);\n  line-height: 0;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n\n  ion-icon {\n    font-size: 18px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.1);\n  }\n\n  &--danger:hover,\n  &--danger:focus-visible {\n    color: var(--ion-color-danger);\n    background: rgba(var(--ion-color-danger-rgb), 0.1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
